import { render, staticRenderFns } from "./jiabing.vue?vue&type=template&id=2b178efe&scoped=true"
import script from "./jiabing.vue?vue&type=script&lang=js"
export * from "./jiabing.vue?vue&type=script&lang=js"
import style1 from "./jiabing.vue?vue&type=style&index=1&id=2b178efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b178efe",
  null
  
)

export default component.exports